import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import HomeTabsSection from "./HomeTabs";

const HomeBeforeLogin: React.FC = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">Welcome Page</h1>
        <div className="mb-4">
          <Breadcrumb separator=">" items={[{ title: "Welcome Page" }, { title: breadcrumb}]} className="text-xs sm:text-base"/>
        </div>
        <HomeTabsSection setBreadcrumb={setBreadcrumb} />
      </div>
    </div>
  );
};

export default HomeBeforeLogin;
